import axiosClient from '@/utils/axios';

const endPoint = '/groups';

export default {
  async getGroupsOverview(payload) {
    const path = `${endPoint}/overview`;

    const response = await axiosClient.post(path, {
      ...payload,
      granularity: '1-months',
    });

    return response.data;
  },

  async getListAllGroup() {
    const path = `${endPoint}/all`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getRetrieveOfGroup(id) {
    const path = `${endPoint}/${id}/plants-of-group`;

    const response = await axiosClient.get(path);

    return response.data;
  },
};
